import { useUserProductsKiosk } from "~/api/products/hooks/use-user-products";
import { type ApiErrorResponse } from "~/api/error";
import { DisplayErrorMessage } from "~/components/display-error-message";

import { ModalError } from "../error/modal-error";
import { ModalLoadingGeneric } from "../loading/modal-loading-generic";

import {
  ModalOutOfStock,
  type ModalOutOfStockProduct
} from "./modal-out-of-stock";

type KioskProduct = { id: string; name: string };

export const toOutOfStockProducts = (
  productIds: string[],
  products: KioskProduct[]
): ModalOutOfStockProduct[] => {
  const nameById = new Map(products.map((p) => [p.id, p.name]));

  return productIds
    .map((id) => ({ id, name: nameById.get(id) }))
    .filter((product): product is ModalOutOfStockProduct =>
      Boolean(product.name)
    );
};

type ModalOutOfStockContainerProps = {
  error: ApiErrorResponse;
  onBack: () => void;
  paymentReversed?: boolean;
};

export const ModalOutOfStockContainer = ({
  error,
  onBack,
  paymentReversed
}: ModalOutOfStockContainerProps) => {
  const { data, isLoading } = useUserProductsKiosk();

  if (isLoading) {
    return <ModalLoadingGeneric />;
  }

  const products = toOutOfStockProducts(
    error.body.productIds ?? [],
    data?.products ?? []
  );

  if (products.length === 0) {
    return (
      <ModalError onClose={onBack}>
        <DisplayErrorMessage error={error} />
      </ModalError>
    );
  }

  return (
    <ModalOutOfStock
      products={products}
      onBack={onBack}
      paymentReversed={paymentReversed}
    />
  );
};
